import React, { useEffect, useState } from 'react';
import { ArrowLeftIcon, ArrowRightIcon, ChevronLeftIcon, ChevronRightIcon } from '@chakra-ui/icons';
import { Flex, IconButton, NumberDecrementStepper, NumberIncrementStepper, NumberInput, NumberInputField, NumberInputStepper, Select, Text, Tooltip } from '@chakra-ui/react';

const Pagination = ({
  gotoPage,
  pageCount,
  canPreviousPage,
  previousPage,
  canNextPage,
  nextPage,
  pageOptions,
  setPageSize,
  pageSize,
  pageIndex,
}) => {
  const [goPageValue, setGoPageValue] = useState(pageIndex + 1);

  // Sync input value with current page index
  useEffect(() => {
    setGoPageValue(pageIndex + 1);
  }, [pageIndex]);

  return (
    <Flex justifyContent={pageOptions.length !== 1 ? 'space-between' : 'end'} mt={2} alignItems="center">
      {pageOptions.length !== 1 && (
        <Flex>
          <Tooltip label="First Page">
            <IconButton
              onClick={() => { gotoPage(0); setGoPageValue(1); }}
              isDisabled={!canPreviousPage}
              icon={<ArrowLeftIcon h={3} w={3} />}
              mr={4}
            />
          </Tooltip>
          <Tooltip label="Previous Page">
            <IconButton
              onClick={() => { previousPage(); setGoPageValue((prev) => Math.max(prev - 1, 1)); }}
              isDisabled={!canPreviousPage}
              icon={<ChevronLeftIcon h={6} w={6} />}
            />
          </Tooltip>
        </Flex>
      )}

      <Flex alignItems="center">
        {pageOptions.length !== 1 && (
          <>
            <Text flexShrink="0" mr={8}>
              Page{' '}
              <Text fontWeight="bold" as="span">
                {pageIndex + 1}
              </Text>{' '}
              of{' '}
              <Text fontWeight="bold" as="span">
                {pageOptions.length}
              </Text>
            </Text>

            <Text flexShrink="0">Go to page:</Text>{' '}
            <NumberInput
              ml={2}
              mr={8}
              w={28}
              min={1}
              max={pageOptions.length}
              value={goPageValue}
              onChange={(value) => {
                const page = Number(value);
                if (page >= 1 && page <= pageOptions.length) {
                  gotoPage(page - 1);
                  setGoPageValue(page);
                }
              }}
            >
              <NumberInputField />
              <NumberInputStepper>
                <NumberIncrementStepper />
                <NumberDecrementStepper />
              </NumberInputStepper>
            </NumberInput>
          </>
        )}

        <Select
          w={32}
          value={pageSize}
          onChange={(e) => {
            const newSize = Number(e.target.value);
            setPageSize(newSize);
            gotoPage(0); // Reset to first page when page size changes
          }}
        >
          {[5, 10, 20, 30, 40, 50].map((size) => (
            <option key={size} value={size}>
              Show {size}
            </option>
          ))}
        </Select>
      </Flex>

      {pageOptions.length !== 1 && (
        <Flex>
          <Tooltip label="Next Page">
            <IconButton
              onClick={() => { nextPage(); setGoPageValue((prev) => Math.min(prev + 1, pageOptions.length)); }}
              isDisabled={!canNextPage}
              icon={<ChevronRightIcon h={6} w={6} />}
            />
          </Tooltip>
          <Tooltip label="Last Page">
            <IconButton
              onClick={() => { gotoPage(pageCount - 1); setGoPageValue(pageOptions.length); }}
              isDisabled={!canNextPage}
              icon={<ArrowRightIcon h={3} w={3} />}
              ml={4}
            />
          </Tooltip>
        </Flex>
      )}
    </Flex>
  );
};

export default Pagination;
